export const projects = [
    {
        id: 1,       
        title: "Kitap Ansiklopedisi",       
        link: "#",
        img:'https://www.pngmart.com/files/8/Website-PNG-File.png',
        description:"The website I shared books that I read"
      },
      {
        id: 2,
        title: "Monster Rolodex",       
        link: "https://ibrahimtaskin.github.io/monster-rolodex/",
        img:'https://www.pngmart.com/files/8/Website-PNG-File.png',
        description:"Generating random monsters api example"
      },
      {
        id: 3,
        title: "Search and Find Pictures",       
        link: "https://search-and-find-pics.netlify.app/",
        img:'https://www.pngmart.com/files/8/Website-PNG-File.png',
        description:"Picture search engine api example"
      },
      {
        id: 4,
        title: "Portfolio App",       
        link: "https://portfolio-gatsby-strapi-temp.netlify.app/",
        img:'https://www.pngmart.com/files/8/Website-PNG-File.png',
        description:"Portfolio App"
      },
]